import { useState, useEffect } from "react";
import axios from "axios";

export default function useAuth(code) {
  const [accessToken, setAccessToken] = useState();
  const [refreshToken, setRefreshToken] = useState();
  const [expiresIn, setExpiresIn] = useState();
  const [attempts, setAttempts] = useState(0); 
  const [userData, setUserData] = useState({});
  const maxAttempts = 5;

  useEffect(() => {
    console.log(code);
    if (!code || accessToken) return;

    const intervalId = setInterval(() => {
      axios
        .post(
          `${process.env.REACT_APP_BACK4APP_SERVER_PATH}/api/login`,
          { code },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then((res) => {
          setAccessToken(res.data.accessToken);
          setRefreshToken(res.data.refreshToken);
          setExpiresIn(res.data.expiresIn);
          if (res.data.userName || res.data.avatarUrl) {
            setUserData({
              userName: res.data.userName || "",
              avatarUrl: res.data.avatarUrl || "",
            });
          }
          clearInterval(intervalId);
          window.history.pushState({}, null, "/");
        })
        .catch((error) => {
          setAttempts((prev) => prev + 1); 
          if (attempts + 1 >= maxAttempts) {
            clearInterval(intervalId); 
            localStorage.removeItem("code");
            window.location = "/";  
          }
        });
    }, 2000);
    return () => clearInterval(intervalId); 
  }, [code, attempts, maxAttempts]);

  useEffect(() => {
    if (!refreshToken || !expiresIn) return;

    const interval = setInterval(() => {
      axios
        .post(
          `${process.env.REACT_APP_BACK4APP_SERVER_PATH}/refresh`,
          { refreshToken },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then((res) => {
          setAccessToken(res.data.accessToken);
          setExpiresIn(res.data.expiresIn);
        })
        .catch(() => {
          localStorage.removeItem("code");
          window.location = "/";
        });
    }, (expiresIn - 60) * 1000);

    return () => clearInterval(interval); 
  }, [refreshToken, expiresIn]);

  return { accessToken, userData };
}